import React from "react";
import { Theme } from "@mui/material";

export const GaugeLabel = ({
  theme,
  title,
  subtitle,
  icon,
}: {
  theme: Theme;
  title: string;
  subtitle: string;
  icon: React.ReactNode;
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        height: "88px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <p
          style={{
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.primary,
            fontSize: "20px",
            fontWeight: 600,
            lineHeight: "28px",
            margin: 0,
            maxWidth: "70px",
            whiteSpace: "break-spaces",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {title}
        </p>
      </div>
      <div
        style={{
          fontFamily: theme.typography.fontFamily,
          color: theme.palette.text.secondary,
          fontSize: "16px",
          lineHeight: "24px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          margin: 0,
        }}
      >
        {icon}
        {subtitle}
      </div>
    </div>
  );
};
